<template>
    <div :class="{expanded: expanded,navigating: isNavigating}" :style="styleObject" class="sidebar">
        <div id="nav">
            <div class="account-container">
                <div class="account-image">
                    <!--<img alt="Vue logo" src="../assets/images/hehe.png" width="79.334" height="79.336">-->
                    <svg xmlns="http://www.w3.org/2000/svg" width="49.334" height="49.336"
                         viewBox="0 0 49.334 49.336">
                        <g id="user_1_" data-name="user (1)" transform="translate(0 0)">
                            <path id="Path_633" data-name="Path 633" class="cls-1"
                                  d="M17.979,39.232l-7.36,4.015a6.614,6.614,0,0,0-1.181.841,24.652,24.652,0,0,0,31.675.082,6.53,6.53,0,0,0-1.3-.869l-7.882-3.94a3.006,3.006,0,0,1-1.662-2.688V33.579a11.9,11.9,0,0,0,.746-.959,18.136,18.136,0,0,0,2.45-4.937,2.476,2.476,0,0,0,1.756-2.355v-3.3A2.464,2.464,0,0,0,34.4,20.2V15.427S35.377,8,25.321,8s-9.076,7.426-9.076,7.426V20.2a2.461,2.461,0,0,0-.825,1.829v3.3A2.475,2.475,0,0,0,16.562,27.4a16.38,16.38,0,0,0,2.984,6.174V36.6A3.009,3.009,0,0,1,17.979,39.232Z"
                                  transform="translate(-0.652 -0.553)"/>
                            <g id="Group_138" data-name="Group 138" transform="translate(0 0)">
                                <path id="Path_634" data-name="Path 634" class="cls-2"
                                      d="M25.09,0A24.652,24.652,0,0,0,8.795,43.527a6.555,6.555,0,0,1,1.17-.832l7.36-4.015a3.007,3.007,0,0,0,1.567-2.639V33.025a16.365,16.365,0,0,1-2.984-6.174,2.476,2.476,0,0,1-1.141-2.077v-3.3a2.464,2.464,0,0,1,.825-1.829V14.872s-.98-7.426,9.076-7.426,9.076,7.426,9.076,7.426v4.772a2.461,2.461,0,0,1,.825,1.829v3.3a2.476,2.476,0,0,1-1.756,2.355,18.136,18.136,0,0,1-2.45,4.937,11.9,11.9,0,0,1-.746.959v3.092a3,3,0,0,0,1.662,2.688l7.882,3.94a6.563,6.563,0,0,1,1.294.868A24.662,24.662,0,0,0,25.09,0Z"
                                      transform="translate(0 0)"/>
                            </g>
                        </g>
                    </svg> 
                </div>
                <div class="account-name">
                    <router-link :to="{name: 'account-edit'}" class="account-link">{{userName}}</router-link>
                </div>
            </div>
            <router-link :to="{name: 'dashboard-main'}" class="nav-element empty">Home</router-link>

            <div :class="{'accordion-open': reports, 'accordion-closed': !reports}" class="accordion nav-element">
                <div @click="reports = !reports" class="accordion-head"><span>{{$t('menu.reports.reports')}}</span>
                    <font-awesome-icon icon="chevron-up" v-if="!reports"/>
                    <font-awesome-icon icon="chevron-down" v-else/>
                </div>
                <transition name="accordion-transition">
                    <div class="accordion-body" v-if="reports">
                        <router-link :to="{name: 'cumulative-reports'}">{{$t('menu.reports.cumulative')}}</router-link> 
                        <router-link :to="{name: 'unit', params: {id: 'all'}}">{{$t('menu.reports.unit')}}</router-link>
                        <router-link :to="{name: 'signals', params: {type: 'cover'}}">{{$t('menu.reports.obscure')}}
                        </router-link>
                        <router-link :to="{name: 'signals', params: {type: 'live'}}">{{$t('menu.reports.activity')}}
                        </router-link>
                        <router-link :to="{name: 'report-manager-config'}" v-if="isAdmin || isDirector">
                            {{$t('menu.reports.automatic')}}
                        </router-link>
                    </div>
                </transition>
            </div>
            <div :class="{'accordion-open': analysis, 'accordion-closed': !analysis}"
                 class="accordion nav-element accordion-open">
                <div @click="analysis = !analysis" class="accordion-head"><span>{{$t('menu.analysis.title')}}</span>
                    <font-awesome-icon icon="chevron-up" v-if="!analysis"/>
                    <font-awesome-icon icon="chevron-down" v-else/>
                </div>
                <transition name="accordion-transition">
                    <div class="accordion-body" v-if="analysis">
                        <router-link :to="{name: 'analysis'}">{{$t('menu.analysis.analysis')}}</router-link>
                    </div>
                </transition>
            </div>
            <div :class="{'accordion-open': administration, 'accordion-closed': !administration}"
                 class="accordion nav-element accordion-open" v-if="isAdmin">
                <div @click="administration = !administration" class="accordion-head"><span>{{$t('menu.administration.administration')}}</span>
                    <font-awesome-icon icon="chevron-up" v-if="!administration"/>
                    <font-awesome-icon icon="chevron-down" v-else/>
                </div>
                <transition name="accordion-transition">
                    <div class="accordion-body" v-if="administration">
                        <router-link :to="{name: 'administer-users'}">
                            {{$t('menu.administration.users')}}
                        </router-link>

                        <router-link :to="{name: 'register-user',params:{user: {}}}">
                            {{$t('menu.administration.register')}}
                        </router-link>

                        <router-link :to="{name: 'manage-groups'}">{{$t('menu.administration.groups')}}</router-link>

                        <router-link :to="{name: 'manage-salons'}">{{$t('menu.administration.salons')}}</router-link>
                        <router-link :to="{name: 'devices'}">{{$t('menu.administration.devices')}}</router-link>
                    </div>
                </transition>
            </div>
            <router-link :to="{name: 'weather'}" class="nav-element empty">{{$t('menu.weather')}}</router-link>
            <router-link :to="{name: 'localization'}" class="nav-element empty">{{$t('menu.localization')}}
            </router-link>
            <router-link :to="{name: 'configuration'}" class="nav-element empty" v-if="isAdmin">
                {{$t('menu.configuration')}}
            </router-link>
            <span @click="logout" class="nav-element empty" v-if="isLoggedIn"><a>{{$t('menu.logout')}}</a></span>
        </div>
        <div :class="{'is-active': isActive}" id="hamburger-container">
            <div :class="{'is-active': isActive}" @click="toggleSideMenu" aria-controls="navigation"
                 aria-label="Menu" class="hamburger hamburger--elastic" role="button" tabindex="0">
                <div class="hamburger-box">
                    <div class="hamburger-inner"></div>
                </div>
            </div>
        </div>
        <div class="overlay" v-if="isNavigating"></div>
    </div>

</template>

<script>

export default {
  name: 'SideBar',
  data() {
    return {
      isActive: false,
      expanded: false,
      reports: false,
      salons: false,
      administration: false,
      analysis: false,
    };
  },
  computed: {
    isNavigating() {
      return this.$store.getters.navigating;
    },
    userName() {
      const name = this.$store.getters.userName;
      if (name.length > 26) {
        return `${this.$store.getters.userName.substring(0, 26)}...`;
      }
      return name;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isDirector() {
      return this.$store.getters.isDirector;
    },
    styleObject() {
      const { cssConfig } = this.$store.getters;
      console.log(cssConfig);
      Object.keys(cssConfig).forEach((v) => {
        if (cssConfig[v].length === 4) {
          const init = cssConfig[v];
          const red = init.charAt(1);
          const green = init.charAt(2);
          const blue = init.charAt(3);
          cssConfig[v] = `#${red}${red}${green}${green}${blue}${blue}`;
        }
      });
      return {
        '--menu-start-color': `${cssConfig.menuBackgroundStart}78`,
        '--menu-end-color': `${cssConfig.menuBackgroundEnd}99`,
        '--menu-rwd-color': `${cssConfig.menuBackgroundStart}`,
        '--menu-background-color': `${cssConfig.menuItemBackground}29`,
        '--menu-highlight-color': `${cssConfig.menuHighlight}33`,
      };
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login');
      });
    },
    toggleSideMenu() {
      this.expanded = !this.expanded;
      this.isActive = !this.isActive;
    },
  }
  ,
};
</script>

<style scoped lang="scss">
    @import '~hamburgers/_sass/hamburgers/hamburgers';

    .sidebar {
        z-index: 0;
        min-width: 329px;
        max-width: 330px;
        min-height: 100%;
        position: relative;
        //height: 1348px;
        //opacity: 0.34;
        /*background: url('./assets/images/sidebar-background.png');*/
        //background: $peacock-blue; /* var(--menu-end-color),wsers */
        background: var(--menu-start-color); /* var(--menu-end-color),wsers */
        background: -moz-linear-gradient(top, var(--menu-start-color) 0%, var(--menu-end-color) 100%);
        /* FF3.6-15 */
        background: -webkit-linear-gradient(top, var(--menu-start-color) 0%, var(--menu-end-color) 100%);
        /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, var(--menu-start-color) 0%, var(--menu-end-color) 100%);
        /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#005fab', endColorstr='#002678', GradientType=0);
        transition: all 300ms ease-in;
        /* IE6-9 */
        @include media('<1025px') {
            position: fixed;
            left: -100%;
            /*background: linear-gradient(to bottom, var(--menu-start-color) 0%, var(--menu-end-color) 100%);*/
            background: var(--menu-rwd-color);
            z-index: 20;
            max-height: 90vh;
            overflow-y: auto;
            max-width: 250px;
            min-width: 240px;
            width: 100%;
            top: 70px;
            &.expanded {
                left: 0;
            }
        }
        @include media('<500px') {
            top: 140px;
        }

        &:before {
            content: '';
            //  background-color: #005FAB;
            -webkit-backdrop-filter: blur(10px);
            // background-size: contain;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: -2;
            opacity: 0.34;

        }

        .account-container {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 30px;
            flex-direction: column;

            .account-image {
                width: 100px;
                height: 100px;
                border-radius: 50%;
                box-shadow: 0 3px 24px 0 #00000029;
                -webkit-backdrop-filter: blur(50px);
                backdrop-filter: blur(50px);
                background-color: var(--menu-background-color);
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 20px;

            }

            .account-name {
                margin-top: 15px;

                a {
                    font-size: rem(15px);

                    text-align: center;
                    line-height: 0;
                    color: white;
                    font-weight: 900;
                    text-decoration: none;
                    text-transform: uppercase;
                }

            }
        }

    }

    .cls-1 {
        fill: #fff;
    }

    .cls-2 {
        fill: #eceff1;
    }

    .nav-element {
        z-index: 1;
        filter: none;
        margin: 5px 30px;
        background: var(--menu-background-color);
        font-weight: 800;
        color: white;
        font-size: rem(13px);
        text-decoration: none;
        text-transform: uppercase;
        display: block;
        opacity: 0.8;
        text-align: left;
        border-radius: 5px;
        cursor: pointer;

        &.empty {
            padding: 15px;

            &:hover {
                background-color: var(--menu-highlight-color);
            }
        }

    }

    .router-link-exact-active {
        background-color: var(--menu-highlight-color);
        padding: 17px;
        border-radius: 5px;
        //opacity: 0.2;
    }

    .accordion {
        transition: 300ms ease-in all;

        .accordion-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid rgba(255, 255, 255, 60%);
            padding: 15px;
            /*border-bottom: 1px solid white;*/
            &:hover {
                background-color: var(--menu-highlight-color);
            }
        }

        .accordion-body {
            padding: 15px;
            display: flex;
            flex-direction: column;
            max-height: 1000px;
            transition: 300ms ease-in all;

            a {
                text-align: left;
                text-transform: capitalize;
                font-weight: 300;
                padding: 17px;
                border-radius: 5px;
                color: white;
                text-decoration: none;
                font-size: rem(15px);

                &:hover {
                    background-color: var(--menu-highlight-color);
                }
            }
        }

        &.accordion-closed {
            .accordion-head {
                border: none;
            }
        }
    }

    .accordion-transition-enter-active, .slide-fade-leave-active {
        transition: all 1800ms ease;
    }

    .accordion-transition-enter-to, .accordion-transition-leave {
        opacity: 1;
        max-height: 1000px;
        /*display: block;*/
    }

    .accordion-transition-leave-to, .accordion-transition-enter {
        opacity: 0;
        max-height: 0;
        /*display: none;*/
    }

    #nav {
        padding-bottom: 125px;
        @include media('<1025px') {
            padding-bottom: 300px;
        }
    }

    #hamburger-container {
        display: none;
        transition: 350ms ease-in all;

        @include media('<1025px') {
            position: fixed;
            left: 0;
            top: 70px;
            z-index: 30;
            display: block;
            background-color: var(--menu-start-color);
            opacity: 50%;
            .hamburger-inner, ::after, ::before {
                background-color: white;
            }
            &.is-active {
                left: 250px;
            }
        }

        @include media('<500px') {
            top: 140px;
        }

    }

    a {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:hover {
            text-decoration: none !important;
        }
    }

    .account-link.router-link-exact-active {
        background: transparent;
    }

    .overlay {
        background-color: transparent;
        position: fixed;
        left: 0;
        top: 0;
        width: 400px;
        height: 100%;
        z-index: 10000;
    }

    .navigating {
        pointer-events: none;
    }
</style>
